import { Injectable, inject } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { AuthBridge } from '@crewdle/auth-bridge';
import { WhiteLabelService } from '@crewdle/white-label/angular';
import { environment } from '../../../environments/environment';

/**
 * Holds the OAuth-style bridge to the centralized auth service
 * (auth.crewdle.ai). Lazily constructed so Firebase is initialized before
 * getAuth() is called.
 *
 * On a partner custom domain the bridge targets the partner's own auth
 * origin (an isolated SSO realm), resolved by the white-label service from
 * this hostname's `domains/{hostname}` doc; crewdle.ai domains keep the
 * environment default.
 */
@Injectable({ providedIn: 'root' })
export class AuthBridgeService {
  private readonly whiteLabel = inject(WhiteLabelService);

  private instance?: AuthBridge;

  get bridge(): AuthBridge {
    if (!this.instance) {
      this.instance = new AuthBridge({
        auth: getAuth(),
        authBaseUrl: () => this.whiteLabel.authBaseUrl(environment.authBaseUrl),
      });
    }
    return this.instance;
  }
}
